import { useAnonRestApi } from '../common';
import { IDoiApi } from '@vivli/features/datasets/infrastructure/interface';
import { Observable } from 'rxjs';

export const useDoiApi = (): IDoiApi => {
    const { handleGet } = useAnonRestApi();

    const getDoi = (doiStem: string): Observable<any> => {
        return handleGet<any>(`/Dois/${doiStem}`);
    };

    return {
        getDoi
    };
};
